import React from "react";

import "normalize.css";
import "./Theme.css";

export const ThemeProvider: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => <div className="theme theme--light">{children}</div>;
